import { makeStyles } from '@fluentui/react-components';
var useContainerStyles = makeStyles({
    container: {
        minHeight: '108px',
        height: '108px',
        width: '100%',
    },
});
export var HeroComponentFallback = {
    useContainerStyles: useContainerStyles,
    node: null,
};
//# sourceMappingURL=HeroComponentFallback.js.map